const TOPICS = [
  { name: '明星恋情曝光', count: '128万讨论', hot: true },
  { name: '综艺名场面', count: '96万讨论', hot: true },
  { name: '影视剧争议', count: '87万讨论', hot: true },
  { name: '网红塌房', count: '74万讨论', hot: true },
  { name: '企业家八卦', count: '65万讨论', hot: false },
  { name: '体育圈内幕', count: '58万讨论', hot: false },
  { name: '音乐节翻车', count: '52万讨论', hot: false },
  { name: '直播行业乱象', count: '47万讨论', hot: false },
  { name: '海外娱乐圈', count: '43万讨论', hot: false },
  { name: '社会热点追踪', count: '39万讨论', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            51吃瓜网站最热话题标签，看看大家都在讨论什么
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {TOPICS.map((topic) => (
            <a
              key={topic.name}
              href="#topics"
              className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full transition-all cursor-pointer whitespace-nowrap ${
                topic.hot
                  ? 'bg-primary-100 text-primary-700 hover:bg-primary-200'
                  : 'bg-background-50 text-foreground-700 hover:bg-background-200 border border-background-200/70'
              }`}
            >
              {topic.hot && (
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-fire-line text-sm text-primary-500"></i>
                </span>
              )}
              <span className="text-sm font-medium">{topic.name}</span>
              <span className="text-xs opacity-60">{topic.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}